import { L } from '@lang';
import { setCookie } from '@djs';
import { envs } from '../../core';

const INITIAL_FRAGMENT_COOKIE_NAME = 'pwa_initial_fragment';

export const linkIosManifest = () => {
  const link = document.createElement('link');

  /**
   * Ссылки в динамическом манифесте должны быть абсолютные, иначе iOS их не понимает
   */
  const url = `${window.location.origin}${window.location.pathname}`;

  const appId = new URLSearchParams(window.location.search).get('appId');
  const prefixContent = [envs.PWA_NAME_PREFIX, appId].filter(Boolean).join('-');
  const prefix = prefixContent ? `[${prefixContent}] ` : '';

  const appName = `${prefix}${L.t('project_name')}`;

  /**
   * Устанавливаем no-http-only cookie, они при добавлении иконки на рабочий стол "прокопируются" в PWA браузер
   * и будут жить там "своей жизнью". Это позволяет передать в PWA диплинк "на первый запуск", и потом его подчистить внутри PWA
   * Трюк «Copy-on-install» (https://habr.com/ru/articles/989862/ и https://progressier.com/pwa-capabilities/cookies-demo)
   */
  setCookie(INITIAL_FRAGMENT_COOKIE_NAME, window.location.hash);

  /**
   * Динамический манифест позволяет передать queryParams из /install/ в установленный PWA.
   * Полезно для utm-меток и query-параметров для тестирования (appId)
   */
  const manifestContent = {
    name: appName,
    short_name: appName,
    start_url: `${url.replace(envs.PATH, envs.LAUNCHER_PATH)}${window.location.search}`,
    theme_color: '#19191a',
    background_color: '#19191a',
    display: 'standalone',
    icons: [
      {
        // обращаемся к директории текущего документа index.html
        src: `${url.replace(/[^/]+$/, '')}192.png`,
        type: 'image/png',
        sizes: '192x192',
      },
      {
        // обращаемся к директории текущего документа index.html
        src: `${url.replace(/[^/]+$/, '')}512.png`,
        type: 'image/png',
        sizes: '512x512',
      },
    ],
  };

  const href = `data:application/manifest+json,${encodeURIComponent(JSON.stringify(manifestContent))}`;

  link.rel = 'manifest';

  link.href = href;
  document.head.appendChild(link);
};
